import {useState, useCallback} from 'react'
import {useTranslation} from 'react-i18next'
import {authClient} from '../auth-client'
import {AuthLayout, AuthLink, ErrorBanner, SuccessBanner, fieldClass, primaryButtonClass} from './auth-layout'

export function ForgotPasswordPage() {
  const {t} = useTranslation()
  const [email, setEmail] = useState('')
  const [error, setError] = useState<string | undefined>()
  const [done, setDone] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = useCallback(async (event: React.SyntheticEvent) => {
    event.preventDefault()
    setSubmitting(true)
    setError(undefined)

    const {error} = await authClient.requestPasswordReset({
      email,
      redirectTo: `${globalThis.location.origin}/reset-password`
    })

    setSubmitting(false)

    if (error) {
      setError(t('auth.forgotPassword.errorDefault'))
      return
    }

    setDone(true)
  }, [email, t])

  return (
    <AuthLayout
      title={t('auth.forgotPassword.title')}
      subtitle={t('auth.forgotPassword.subtitle')}
      footer={<AuthLink to='/sign-in'>{t('auth.forgotPassword.backToSignIn')}</AuthLink>}
    >
      {done
        ? <SuccessBanner message={t('auth.forgotPassword.successMessage', {email})} />
        : (
          <form onSubmit={handleSubmit} className='flex flex-col gap-4'>
            {error && <ErrorBanner message={error} />}
            <input
              type='email' placeholder={t('auth.fields.email')} value={email}
              required autoFocus
              autoComplete='email' className={fieldClass}
              onChange={e => {
                setEmail(e.target.value)
              }}
            />
            <button type='submit' disabled={submitting} className={primaryButtonClass}>
              {submitting ? t('auth.forgotPassword.submitting') : t('auth.forgotPassword.submit')}
            </button>
          </form>
        )}
    </AuthLayout>
  )
}
